import configuration from '../utilities/configuration';
import localStorage from "../utilities/localStorage";
import { ACCESS_TOKEN, ID_TOKEN, REFRESH_TOKEN } from "./authClient/src/constants";
import { oauthToken } from "./authClient/src/utils";

export async function getTokenFromRefreshToken() {
    let authResult;
    try {
        authResult = await oauthToken({
            tokenEndpoint: configuration.authServerUrl + configuration.authTokenEndpoint,
            grant_type: REFRESH_TOKEN,
            client_id: configuration.authClientId,
            refresh_token: localStorage.getItem(REFRESH_TOKEN),
        });
    } catch (e) {
        return false;
    }

    localStorage.setItem(ID_TOKEN, authResult.id_token);
    localStorage.setItem(ACCESS_TOKEN, authResult.access_token);

    return true;
}

export function getRefreshToken() {
    return localStorage.getItem(REFRESH_TOKEN);
}

export function getBearerHeader() {
    const accessToken = localStorage.getItem(ACCESS_TOKEN);
    return !accessToken ? {} : {Authorization: `Bearer ${accessToken}`};
}